import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Avatar from "@mui/material/Avatar";
import { ClickAwayListener } from "@mui/base";
import { StyledPaper } from "./SettingsDropDown.styles";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { selectOrganizations } from "store/user/user.selectors";
import { useNavigate } from "react-router-dom";
import { updateAuthentication } from "store/auth/auth.slice";
import { updateUser } from "store/user/user.slice";
import * as UserServiceApi from "apis/UserServiceApi";
import * as AuthServiceApi from "apis/AuthServiceApi";
import { Divider } from "@mui/material";

interface Organization {
  organization_id: number;
  name: string;
  socialAvatarUrl?: string;
}

interface Props {
  openSwitchAccounts: boolean;
  setOpenSwitchAccounts: (b: boolean) => void;
  setOpenMenu: (b: boolean) => void;
}

export function SwitchAccountsMenu({
  openSwitchAccounts,
  setOpenSwitchAccounts,
  setOpenMenu,
}: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const personalSession = useAppSelector((state) => state.auth.personalSession);
  const organizations = useAppSelector(selectOrganizations);
  const personalProfile = useAppSelector((s) => s.auth.personalProfile);
  const { currentSession, currentOrganizationId } = useAppSelector(
    (s) => s.auth
  );
  const showPersonal = currentSession !== "myself";
  const orgsToShow = organizations.filter(
    (o) => o.organization_id !== currentOrganizationId
  );
  async function handlePersonal() {
    if (!personalSession) return;
    dispatch(
      updateAuthentication({
        ...personalSession,
        currentSession: "myself",
        currentOrganizationId: undefined,
      })
    );
    const userInfo = await UserServiceApi.getUserByUserId(
      personalSession.userId
    );
    dispatch(updateUser(userInfo));
    setOpenSwitchAccounts(false);
    navigate("/feed"); // o la ruta que prefieras
  }
  async function handleOrg(org: Organization) {
    try {
      const orgResponse = await AuthServiceApi.loginOrganization(
        org.organization_id
      );
      dispatch(
        updateAuthentication({
          accessToken: orgResponse.accessToken,
          tokenType: orgResponse.tokenType,
          expiresIn: orgResponse.expiresIn,
          userId: orgResponse.userId,
          userType: orgResponse.userType,
          templateType: orgResponse.templateType,
          role: orgResponse.role,
          currentSession: "organization",
          currentOrganizationId: org.organization_id,
        })
      );
      const info = await UserServiceApi.getUserByUserId(orgResponse.userId);
      dispatch(updateUser(info));
      setOpenSwitchAccounts(false);
      navigate("/org/home");
    } catch (e) {
      console.error(e);
    }
  }
  function handleBack() {
    setOpenSwitchAccounts(!openSwitchAccounts);
    setOpenMenu(true); // vuelve al menú principal
  }

  function handleClickAway() {
    setOpenSwitchAccounts(false);
  }
  console.log(personalProfile, "personalProfile");

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <StyledPaper>
        <MenuList>
          <MenuItem onClick={handleBack}>
            <ListItemIcon>
              <KeyboardArrowLeftIcon htmlColor="#000000" />
            </ListItemIcon>
            <ListItemText>
              <b>Organizations</b>
            </ListItemText>
          </MenuItem>

          {organizations.length === 0 && (
            <MenuItem sx={{ cursor: "auto", pl: 5 }}>
              <ListItemText>No organizations</ListItemText>
            </MenuItem>
          )}
          <MenuList>
            {showPersonal && personalProfile && (
              <MenuItem onClick={handlePersonal} sx={{ pl: 5 }}>
                <ListItemIcon>
                  <Avatar
                    src={personalProfile.avatar}
                    sx={{ width: 24, height: 24 }}
                  />
                </ListItemIcon>
                <ListItemText>{personalProfile.name}</ListItemText>
              </MenuItem>
            )}
            {orgsToShow.length > 0 && showPersonal && <Divider />}
            {orgsToShow.length > 0 && !showPersonal && <Divider />}

            {orgsToShow.map((org) => (
              <MenuItem
                key={org.organization_id}
                onClick={() => handleOrg(org)}
                sx={{ pl: 5 }}
              >
                <ListItemIcon>
                  <Avatar
                    src={org.socialAvatarUrl}
                    sx={{ width: 24, height: 24 }}
                  />
                </ListItemIcon>
                <ListItemText>{org.name}</ListItemText>
              </MenuItem>
            ))}
          </MenuList>
        </MenuList>
      </StyledPaper>
    </ClickAwayListener>
  );
}
